module.exports = __webpack_public_path__ + "img/building.118f4001.png";